// Homepage Apple-Like SLIDER
// Homepage Apple-Like SLIDER
$(function () {

    initInterval = null;

    // Remove all "is-selected" except for the first one
    function modifyAppleLikeSlider () {

        const homepageAppleLikeSectionSelector = "#shopify-section-template--16082917621922__dc414110-92bc-4f03-b5bb-43195cf61a24 .flickity-enabled"
        const $hpAppleLike = $(homepageAppleLikeSectionSelector)

        //const sliderReady = $hpAppleLike.find('').length
        ///console.log(sliderReady)
        if ( ! $hpAppleLike.length ) {
            return
        }
        
        $hpAppleLike.find('.slideshow__slide').each( ( index, elmnt ) => {
            if ( index > 0 ) {
                elmnt.classList.remove('is-selected')
            }
        })

        clearInterval(initInterval)
    }
    
    initInterval = window.setInterval( modifyAppleLikeSlider, 2000 )

})

// Collection Description Menus
// Collection Description Menus
$(() => {
    
    if ( ! $('#collection-description-menu').length )
        return

    // Add width to each link elements
    // Add width to each link elements
    const width_compensation = 25
    $('#collection-description-menu li a').each( (i,a) => $(a).width( $(a).width() + width_compensation ))

    // Scroll the menu to display the current collection
    document.querySelector('#collection-description-menu li:has(strong)').scrollIntoView({behavior:"instant",block:"nearest",inline:"center"})

})

// Collection Template: Collection List SLIDER
// Collection Template: Collection List SLIDER
$(() => {
    
})